var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, type, defaultValue, Schema } from "../../decorators/type.js";
import { addEnums } from "../../constants/index.js";
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { EntityFactory } from "../../entity/EntityFactory.js";
import { C as ChildSchema } from "../../Child-888ef1d8.js";
import { SpawnSchema } from "../entity/Spawn.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../enums-86f58524.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
import "../../loader/AssetLoader.js";
import "../../loader/ImageLoader.js";
import "pixi.js";
import "../../loader/SpriteLoader.js";
import "../../loader/PixiSpriteLoader.js";
import "../../loader/MapLoader.js";
import "../../utils/colors.js";
import "../../utils/sharedFetch.js";
import "../../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../../persist/persist.js";
import "../../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../../loader/SoundLoader.js";
import "../../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "lodash";
import "../../Parent-b4f1af10.js";
import "./ListenEntityCreation.js";
import "../../utils/vector.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
var AnimationEase = /* @__PURE__ */ ((AnimationEase2) => {
  AnimationEase2[AnimationEase2["LINEAR"] = 0] = "LINEAR";
  AnimationEase2[AnimationEase2["QUADRATIC"] = 1] = "QUADRATIC";
  AnimationEase2[AnimationEase2["CUBIC"] = 2] = "CUBIC";
  AnimationEase2[AnimationEase2["QUARTIC"] = 3] = "QUARTIC";
  AnimationEase2[AnimationEase2["QUINTIC"] = 4] = "QUINTIC";
  AnimationEase2[AnimationEase2["SINUSOIDAL"] = 5] = "SINUSOIDAL";
  AnimationEase2[AnimationEase2["EXPONENTIAL"] = 6] = "EXPONENTIAL";
  AnimationEase2[AnimationEase2["CIRCULAR"] = 7] = "CIRCULAR";
  AnimationEase2[AnimationEase2["ELASTIC"] = 8] = "ELASTIC";
  AnimationEase2[AnimationEase2["BACK"] = 9] = "BACK";
  AnimationEase2[AnimationEase2["BOUNCE"] = 10] = "BOUNCE";
  return AnimationEase2;
})(AnimationEase || {});
addEnums({
  AnimationEase
});
let AnimationTweenSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "start");
    __publicField(this, "end");
    __publicField(this, "duration");
    __publicField(this, "frameStart");
    __publicField(this, "ease");
  }
};
__decorateClass([
  type("number")
], AnimationTweenSchema.prototype, "start", 2);
__decorateClass([
  type("number")
], AnimationTweenSchema.prototype, "end", 2);
__decorateClass([
  type("number")
], AnimationTweenSchema.prototype, "duration", 2);
__decorateClass([
  type("number")
], AnimationTweenSchema.prototype, "frameStart", 2);
__decorateClass([
  type(AnimationEase),
  defaultValue(
    0
    /* LINEAR */
  )
], AnimationTweenSchema.prototype, "ease", 2);
AnimationTweenSchema = __decorateClass([
  Component("AnimationTween")
], AnimationTweenSchema);
let AnimationSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "property");
    __publicField(this, "componentType");
    __publicField(this, "loop");
    __publicField(this, "relative");
    __publicField(this, "previousValue");
    __publicField(this, "tweens");
    __publicField(this, "spawnChildOnComplete");
    __publicField(this, "applyToParent");
  }
};
__decorateClass([
  type("string")
], AnimationSchema.prototype, "property", 2);
__decorateClass([
  type("string")
], AnimationSchema.prototype, "componentType", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], AnimationSchema.prototype, "loop", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], AnimationSchema.prototype, "relative", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], AnimationSchema.prototype, "previousValue", 2);
__decorateClass([
  type([AnimationTweenSchema])
], AnimationSchema.prototype, "tweens", 2);
__decorateClass([
  type(SpawnSchema)
], AnimationSchema.prototype, "spawnChildOnComplete", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], AnimationSchema.prototype, "applyToParent", 2);
AnimationSchema = __decorateClass([
  Component("Animation")
], AnimationSchema);
let AnimateSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "animations");
  }
};
__decorateClass([
  type([AnimationSchema])
], AnimateSchema.prototype, "animations", 2);
AnimateSchema = __decorateClass([
  Component("Animate")
], AnimateSchema);
class AnimateSystem {
  constructor() {
    __publicField(this, "schema", AnimateSchema);
    __publicField(this, "type", "Animate");
    __publicField(this, "depth", DEPTHS.PREDRAW - 1);
  }
  init(entity, gameModel) {
    const animate2 = gameModel.getTypedUnsafe(entity, AnimateSchema);
    for (let i = 0; i < animate2.animations.length; i++) {
      const animation = animate2.animations[i];
      animation.tweens[0].frameStart = gameModel.timeElapsed;
      if (animation.relative) {
        animation.previousValue = 0;
      }
    }
  }
  run(entity, gameModel) {
    var _a, _b;
    const animate2 = gameModel.getTypedUnsafe(entity, AnimateSchema);
    if (!animate2) {
      return;
    }
    const parent = (_a = gameModel.getTyped(entity, ChildSchema)) == null ? void 0 : _a.parent;
    for (let i = 0; i < animate2.animations.length; i++) {
      const animation = animate2.animations[i];
      const tween = animation.tweens[0];
      const progress = (gameModel.timeElapsed - tween.frameStart) / tween.duration;
      const easedProgress = this.ease(progress, tween.ease);
      const value = this.lerp(tween.start, tween.end, easedProgress);
      const component = animation.applyToParent ? gameModel.getComponent(parent ?? -1, animation.componentType) : gameModel.getComponent(entity, animation.componentType);
      if (component && component[animation.property] !== void 0) {
        if (animation.relative) {
          let relativePosition = component[animation.property] - animation.previousValue;
          component[animation.property] = relativePosition + value;
          animation.previousValue = value;
        } else {
          component[animation.property] = value;
        }
      }
      if (progress >= 1) {
        const shiftedTween = animation.tweens.shift();
        if (animation.loop) {
          animation.tweens.push(shiftedTween);
        }
        if (animation.tweens.length > 0) {
          animation.tweens[0].frameStart = gameModel.timeElapsed;
        } else {
          if (animation.spawnChildOnComplete) {
            let overrides = {
              Child: { parent: entity }
            };
            for (let i2 = 0; i2 < ((_b = animation.spawnChildOnComplete.overrideComponents) == null ? void 0 : _b.length); i2++) {
              const override = animation.spawnChildOnComplete.overrideComponents[i2];
              overrides[override.type] = override.data;
            }
            EntityFactory.getInstance().generateEntity(
              gameModel,
              animation.spawnChildOnComplete.description,
              overrides
            );
          }
          animate2.animations.splice(i, 1);
          i--;
          if (animate2.animations.length === 0) {
            gameModel.removeComponent(entity, this.type);
          }
        }
      }
    }
  }
  lerp(start, end, progress) {
    return start + (end - start) * progress;
  }
  ease(progress, ease) {
    switch (ease) {
      case 0:
        return progress;
      case 1:
        return progress * progress;
      case 2:
        return progress * progress * progress;
      case 3:
        return progress * progress * progress * progress;
      case 4:
        return progress * progress * progress * progress * progress;
      case 5:
        return 1 - Math.cos(progress * Math.PI / 2);
      case 6:
        return progress === 0 ? 0 : Math.pow(2, 10 * (progress - 1));
      case 7:
        return 1 - Math.sqrt(1 - progress * progress);
      case 8:
        return -1 * Math.pow(2, -10 * progress) * Math.sin((progress - 0.075) * (2 * Math.PI) / 0.3);
      case 9:
        return progress * progress * (2.70158 * progress - 1.70158);
      case 10:
        if (progress < 1 / 2.75) {
          return 7.5625 * progress * progress;
        } else if (progress < 2 / 2.75) {
          return 7.5625 * (progress -= 1.5 / 2.75) * progress + 0.75;
        } else if (progress < 2.5 / 2.75) {
          return 7.5625 * (progress -= 2.25 / 2.75) * progress + 0.9375;
        } else {
          return 7.5625 * (progress -= 2.625 / 2.75) * progress + 0.984375;
        }
    }
  }
}
const animate = (entity, animation, gameModel) => {
  if (!gameModel.hasComponent(entity, "Animate")) {
    gameModel.addComponent(entity, "Animate");
  }
  animation.tweens[0].frameStart = gameModel.timeElapsed;
  const animate2 = gameModel.getTypedUnsafe(entity, AnimateSchema);
  animate2.animations.push(animation);
};
registerSystem(AnimateSystem);
export {
  animate
};
//# sourceMappingURL=Animate.js.map
